import React from "react";
import { isStandalonePWA, isMobile } from "../../../functions/device"
import { useTopSnapBack } from "./TopSnapBack"
import './PwaPullToRefresh.css'
import { FaArrowDown, FaCircleNotch } from "react-icons/fa";

type Props = {
  children: React.ReactNode;
  onRefresh: () => Promise<any> | any;
};

export const PwaPullToRefresh: React.FC<Props> = ({ children, onRefresh }) => {
  const allowRefresh = isStandalonePWA() && isMobile();
  const [isPulling, setIsPulling] = React.useState(false);
  const [isRefreshing, setIsRefreshing] = React.useState(false);

  React.useEffect(() => {
    if (!allowRefresh) return;

    return useTopSnapBack(document.body, {
      onPull: (distance) => {
        if (!isRefreshing) setIsPulling(distance > 0);
      },
      onThreshold: async () => {
        if (!isRefreshing) {
          setIsRefreshing(true);
          await new Promise(r => setTimeout(r, 300));
          await onRefresh();
        }
      },
      onRelease: () => {
        if (!isRefreshing) setIsPulling(false);
      }
    });
  }, [allowRefresh, isRefreshing, onRefresh]);

  return (
    <>
      {allowRefresh && (
        <div className="ptr-background">
          {!isRefreshing && <FaArrowDown className="ptr-arrow" />}
          {isRefreshing && (
            <FaCircleNotch style={{ animation: "spin 1s linear infinite" }} />
          )}
        </div>
      )}

      {children}
    </>
  );
};

